const Chevron = props => (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.6269 14.7272L16.7409 10.7258C16.9245 10.5486 17.0304 10.3049 17.0348 10.0489C17.0393 9.79278 16.942 9.54554 16.7647 9.36206C16.3993 8.98321 15.7986 8.97273 15.4202 9.33859L11.9854 12.6794L8.66926 9.22076C8.30385 8.8419 7.7032 8.83142 7.32479 9.19729C7.14314 9.37541 7.03936 9.61903 7.03635 9.87433C7.03045 10.1296 7.12566 10.3767 7.30099 10.561L11.2729 14.7036C11.4487 14.8885 11.6907 14.9951 11.9449 14.9995C12.1991 15.0039 12.4446 14.9059 12.6269 14.7272Z" />
  </svg>
);

export { Chevron };
